function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookSaved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/twotone/book-saved"
  }, /*#__PURE__*/React.createElement("g", {
    id: "book-saved"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.4163 3.69701V13.2524C17.4163 14.0124 16.7988 14.7249 16.0388 14.8199L15.7776 14.8516C14.0518 15.0812 11.3917 15.9599 9.87173 16.7991C9.6659 16.9178 9.32552 16.9178 9.11177 16.7991L9.08007 16.7833C7.56007 15.952 4.90803 15.0812 3.19011 14.8516L2.9605 14.8199C2.2005 14.7249 1.58301 14.0124 1.58301 13.2524V3.68908C1.58301 2.747 2.3509 2.03451 3.29299 2.11368C4.95549 2.24826 7.47298 3.08745 8.88215 3.9662L9.08007 4.08492C9.30965 4.22742 9.6897 4.22742 9.91928 4.08492L10.0539 3.99785C10.5526 3.6891 11.1859 3.38034 11.8747 3.10326C12.9118 2.69159 14.0676 2.35913 15.0413 2.2008C15.2551 2.16121 15.4609 2.13743 15.6509 2.1216H15.6984C16.6405 2.04243 17.4163 2.74701 17.4163 3.69701Z",
    stroke: "#3674CB",
    style: {
      stroke: "#3674CB",
      stroke: "color(display-p3 0.2118 0.4549 0.7961)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.5 4.34619V16.2212",
    stroke: "#3674CB",
    style: {
      stroke: "#3674CB",
      stroke: "color(display-p3 0.2118 0.4549 0.7961)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.0417 2.20093V6.3334L13.4583 5.28047L11.875 6.3334V3.10339C12.9121 2.69172 14.0679 2.35926 15.0417 2.20093Z",
    stroke: "#3674CB",
    style: {
      stroke: "#3674CB",
      stroke: "color(display-p3 0.2118 0.4549 0.7961)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookSaved);
export default __webpack_public_path__ + "static/media/book-saved.3f4b72915b786ecf82ff55fe1b0388cc.svg";
export { ForwardRef as ReactComponent };